import { Box, useTheme } from "@mui/material";
import React, { useMemo } from "react";

import CustomChip from "./CustomChip";

const ShowTaskTags = (props: any) => {
  const theme = useTheme();
  const { tags } = props;

  const allTags = useMemo(() => {
    const updatedTags: Record<string, React.ReactNode> = {};
    if (tags && tags?.length > 0) {
      tags.forEach((tag: any) => {
        if (tag) {
          updatedTags[tag.name] = (
            <CustomChip
              label={tag.name}
              textColor={tag.text_color_code}
              bgColor={tag.background_color_code}
            />
          );
        }
      });
    }
    return updatedTags;
  }, [tags]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          borderRadius: "4px",
          minHeight: "56px",
          padding: "8px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          border: "1px solid #cccccc",
          alignItems: "center",
          "&:hover": {
            border: `1px solid ${theme.vars.palette.primary.main}`,
          },
          "&:active": {
            boxShadow: `inset 0 0 0 1px ${theme.vars.palette.primary.main}`,
          },
        }}
      >
        {Object.keys(allTags).map((key, index) => {
          if (allTags[key]) {
            return <div key={`tag-key-${index}`}>{allTags[key]}</div>;
          }
        })}
      </Box>
    </>
  );
};

export default ShowTaskTags;
